import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type dateProps = {
  children?: ReactNode;
  className?: string;
  dateTime?: string;
};

export default function Date({ children, className, dateTime }: dateProps) {
  return (
    <p
      data-testid="date"
      className={twMerge(
        "font-primary font-medium text-gray-150 text-xs",
        className,
      )}
      {...(dateTime ? { "data-beyondwords-publish-date": dateTime } : {})}
    >
      {children}
    </p>
  );
}
